<style lang="scss" scoped>
@import '../css/sub.scss';

.container {
    margin: 0 auto;
    width: 90%;
    max-width: 1200px;
    display: flex;
    gap: 0 10px;
    margin-top: 20px;
  }
  .group:after {
    content: "";
    display: table;
    clear: both;
  }
  .grid-1-5 {
    border: 2px solid #5d4e65;
    min-height: 400px;
    padding: 1.25em;
    position: relative;
    text-align: center;
    transition: all .2s ease-in-out;
  }
  .grid-1-5:hover {
    background-color: rgb(83,69,91);
    border-top: 2px solid #ec7a37;
    border-bottom: 2px solid #ff4f69;
    box-shadow: 0px 0px 10px 0px rgba(50, 50, 50, 1);
    transform: scale(1.025);
    z-index: 2;
  }
</style>
<template>
  <div class="urban-asset board-page">
    <urban-header></urban-header>
    <div class="urban-sub">
      <div class="board-contents">
        <h2 class="title">공지사항</h2>
        <div class="search-area">
          <input type="text" class="search-input" @input="itemChanged"  @keyup.enter="searchNotice()" placeholder="찾고자하는 게시물을 입력하세요.">
          <button type="button" class="search-btn" @click="searchNotice()"></button>
        </div>
        <div class="board-template">
          <ul class="board-list" v-if="board">
            <li class="list-item" v-for="item in boardList" :key="item.index">
              <button type="button" class="item-btn" @click="boardDetailView(item.notiTitle, item.notiCd, item.notiCreateTime, item.notiDesc)">
                <span class="label important" v-if="'001' === item.notiCd">중요공지</span>
                <span class="label" v-else>일반공지</span>
                <span class="tit">{{item.notiTitle | truncate(40, '...')}}</span>
                <span class="date">{{item.notiCreateTime}}</span>
                <i class="icon plus-icon"></i>
              </button>
            </li>
          </ul>
        </div>
        <div class="popup-template" v-if="boardDetail">
          <div class="popup-container">
            <div class="popup-contents">
              <div class="header">
                <span class="title-column">
                  <span class="label important" v-if="'001' === this.detailImportant">중요공지</span>
                  <span class="label" v-else>일반공지</span>
                  <span class="tit">{{this.detailTit}}</span>
                </span>
                  <span class="date">{{this.detailDate}}</span>
              </div>
              <div class="contents">
                <!--<p class="default-txt">{{this.detailDesc}}</p>-->
                <div class="contents" v-html ="this.detailDesc"></div>
                <!--<p class="default-txt">1. 땡처리부동산닷컴 서비스 약관 신설</p>
                <p class="default-txt">
                  제17조 (이용자의 의무)
                </p>
                <p class="default-txt">
                  (1) 회사의 임직원, 피용자, 상담원, 업무수탁자(이하‘임직원등’)에게 폭력적, 명예훼손적, 모욕적, 또는 성적 굴욕감이나 혐오감을 유발할 수 있는 발언이나 행동을 하는 행위</p>-->
              </div>
              <div class="footer">
                <button type="button" class="close-btn" @click="boardDetail=false">닫기</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <urban-footer></urban-footer>
  </div>
</template>
<script>
import UrbanHeader from '@/components/UrbanHeader'
import UrbanFooter from '@/components/UrbanFooter'

import { mapGetters } from 'vuex'

export default {
  name: 'ViewNotice',
  components: {
    'urban-header': UrbanHeader,
    'urban-footer': UrbanFooter
  },
  mounted () {
    this.initNotice()
  },
  data () {
    return {
      board: true,
      listTit: '',
      boardDetail: false,
      detailTit: '',
      detailDate: '',
      detailImportant: false,
      detailDesc: ''
    }
  },
  watch: {
    boardList () {
      if (this.$route.params.id !== undefined) {
        var id = parseInt(this.$route.params.id)
        var tmp = ''
        for (var i = 0; i < this.boardList.length; i++) {
          if (this.boardList[i].notiId === id) {
            tmp = this.boardList[i]
            break
          }
        }
        if (tmp !== '') {
          this.boardDetailView(tmp.notiTitle, tmp.notiCd, tmp.notiCreateTime, tmp.notiDesc)
          this.$route.params.id = undefined
        }
      }
    }
  },
  methods: {
    initNotice: function () {
      this.$store.dispatch('apiNotices', {'keyWord': ''})
    },
    itemChanged: function (e) {
      this.listTit = e.target.value
      // this.searchNotice()
    },
    boardDetailView: function (tit, important, date, desc) {
      this.boardDetail = true
      this.detailTit = tit
      this.detailDate = date
      this.detailImportant = important
      this.detailDesc = desc
    },
    searchNotice: function () {
      this.$store.dispatch('apiNotices', {'keyWord': this.listTit})
    }
  },
  computed: {
    ...mapGetters({
      boardList: 'getNotices'
    })
    /* ,
    filtered: function () {
      let pTit = this.listTit.trim() // 문자열 앞과 뒤 공백제거
      return this.boardList.filter(function (item, index) { // 지정된 조건에 맞는 요소 새롭게 반환
        if (item.tit.indexOf(pTit) !== -1) {
          return true
        }
      })
    } */
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ViewNotice.vue